import React from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
//import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {Owner} from './Inc';
import Title from './Title';
import StoreImg from './StoreImg';
import useStyles from './Styles';

interface TopSalesListProps {
    owner:Owner,
    list:any[],
}

const TopSalesList:React.FC<TopSalesListProps> = (props)=> {
	const classes = useStyles();
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // 960px以上
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm')); // 600px以上

    let colSpan = 2;
    if (isMdUp) {
        colSpan = 5;
    } else if (isSmUp) {
        colSpan = 3;
    } // xsは2, smは3, md以上は5
	return (
        <Box style={{marginBottom:"4em"}}>
            <Title text="売上履歴"/>
            <Table>
                <TableHead>
                    <TableRow style={{height:"2em"}}>
                        <TableCell className={classes.tableHeadNowrap}>受注日時</TableCell>
                        <TableCell
                            className={classes.tableHeadNowrap}
                            sx={{ display: { xs:'none', sm: 'none', md: 'table-cell' } }}
                        >
                            店舗
                        </TableCell>
                        <TableCell className={classes.tableHeadNowrap}>商品</TableCell>
                        <TableCell
                            className={classes.tableHeadNowrap}
                            sx={{ display: { xs: 'none', sm: 'table-cell' } }}
                        >
                            個数
                        </TableCell>
                        <TableCell
                            className={classes.tableHeadNowrap}
                            sx={{ display: { xs:'none', sm: 'none', md: 'table-cell' } }}
                        >
                            小計
                        </TableCell>
                    </TableRow>
                </TableHead>
                {props.list ? (
                <TableBody>
                    {props.list.map( (sales,index)=>{
                        const key = "sales"+index;
                        const badgeClass = "badge badgeStore"+sales.order_type_id;
                        return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCellNowrap}>{sales.order_date}<br/>{sales.order_time}</TableCell>
                        <TableCell
                            className={classes.tableCellNowrap}
                            sx={{ display: { xs: 'none', md: 'table-cell' } }}
                        >
                            <span className={badgeClass}>{sales.store_name}</span>
                        </TableCell>
                        <TableCell className={classes.tableCellDense}>
                            <div className="itemImgName">
                                <div className="img"><StoreImg owner_id={props.owner.owner_id} img_id={sales.img_id} thumb={true} className="imgItemThumbSmall"/></div>
                                <div className="itemName" style={{marginLeft:'80px',minHeight:'45px'}}>{sales.item_name}</div>
                            </div>
                        </TableCell>
                        <TableCell
                            className={classes.tableCellNowrap}
                            sx={{ display: { xs: 'none', sm: 'table-cell' }, textAlign: "right" }}
                        >
                            {sales.su}{sales.unit}
                        </TableCell>
                        <TableCell
                            className={classes.tableCellNowrap}
                            sx={{ display: { xs: 'none', md: 'table-cell' }, textAlign: "right" }}
                        >
                            {sales.shokei}円
                        </TableCell>
                    </TableRow>
                        )
                    })}
                </TableBody>
                ):(
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={colSpan} style={{textAlign:"center",padding:'1em 0',color:'grey'}}>なし</TableCell>
                        </TableRow>
                    </TableBody>
                )}
            </Table>
            {props.owner.owner_id>0 &&
            <nav className={classes.more}>
                <Link to="/sale" className={classes.link}><ArrowForwardIcon/>売上履歴をもっと見る</Link>
            </nav>
            }
        </Box>
    );
}

export default TopSalesList;
